import { MyLogDefinition } from './log.my.d'

export default {
  my: {
    page_id: '/my',
    action_id: {
      viewProfileToggle: 'view.profile_toggle',
      tapProfileToggle: 'tap.profile_toggle',
      tapMyinfo: 'tap.myinfo',
      viewProfileTooltip: 'view.profile_tooltip',
      tapProfileTooltip: 'tap.profile_tooltip',
      viewCarprofile: 'view.carprofile',
      tapCarprofile: 'tap.carprofile',
      viewUbiBanner: 'view.ubi_banner',
      tapUbiBanner: 'tap.ubi_banner',
      tapUbiBannerClose: 'tap.ubi_banner_close',
      viewPoint: 'view.point',
      tapPoint: 'tap.point',
      viewPointshopTooltip: 'view.pointshop_tooltip',
      tapPointshopTooltip: 'tap.pointshop_tooltip',
      viewMileage: 'view.mileage',
      tapMileage: 'tap.mileage',
      tapReward: 'tap.reward',
      viewPoiCoupon: 'view.poi_coupon',
      tapPoiCoupon: 'tap.poi_coupon',
      viewCoupon: 'view.coupon',
      tapCoupon: 'tap.coupon',
      viewMovingLog: 'view.moving_log',
      tapMovingLog: 'tap.moving_log',
      viewCavatarStore: 'view.cavatar_store',
      tapCavatarStore: 'tap.cavatar_store',
      viewMission: 'view.mission',
      tapMissionAll: 'tap.mission_all',
      tapMissionBanner: 'tap.mission_banner',
      viewDailyQuiz: 'view.daily_quiz',
      tapDailyQuizCorrectAnswer: 'tap.daily_quiz_correct_answer',
      tapDailyQuizIncorrectAnswer: 'tap.daily_quiz_incorrect_answer',
      tapDailyQuizCta: 'tap.daily_quiz_cta',
      tapDailyQuizClose: 'tap.daily_quiz_close',
      viewPedometer: 'view.pedometer',
      tapPedometer: 'tap.pedometer',
      viewAvailableReview: 'view.available_review',
      tapAvailableReview: 'tap.available_review',
      viewWritingReview: 'view.writing_review',
      tapWritingReview: 'tap.writing_review',
      viewAvailableReviewMore: 'view.available_review_more',
      tapAvailableReviewMore: 'tap.available_review_more',
      tapAd: 'tap.ad',
      tapBizPlaceBanner: 'tap.biz_place_banner',
      tapBusinessInfo: 'tap.business_info',
      viewRecentFollowingContent: 'view.recent_following_content',
      tapRecentFollowingContent: 'tap.recent_following_content',
      viewSurveyQuiz: 'view.survey_quiz',
      tapSurveyQuiz: 'tap.survey_quiz',
    },
  },
  usage: {
    page_id: '/usage',
    action_id: {
      tapBack: 'tap.back',
      tapDriver: 'tap.driver',
      tapScooter: 'tap.scooter',
      tapEvcharge: 'tap.evcharge',
      tapParking: 'tap.parking',
      tapPickup: 'tap.pickup',
    },
  },
  communication: {
    page_id: '/communication',
    action_id: {
      tapComm: 'tap.comm',
    },
  },
  event: {
    page_id: '/event',
    action_id: {
      tapEvent: 'tap.event',
    },
  },
  communicationDetail: {
    page_id: '/communication_detail',
    action_id: {
      tapButton: 'tap.button',
    },
  },
  eventDetail: {
    page_id: '/event_detail',
    action_id: {
      tapButton: 'tap.button',
    },
  },
} as MyLogDefinition
